const getBaseUrl = () => {
    // return 'https://app-service-api-yarsi.vercel.app/';
    // return 'http://localhost:3002/'
    // return 'http://172.16.40.44:3002/'
    return 'https://dev.be.rsyarsi.co.id/';

};

export default getBaseUrl;